<template>
  <light-box @close="discardChanges">
    <div slot="light-box-content">
      <mpe-editor
        v-if="!isFetching"
        :mpeStripped="getEditMpe"
        :availableMedia="getMedia"
        :fetchingData="isFetching"
        @discardChanges="discardChanges"
        @updateMpe="saveMpe" />

      <div
        v-else
        class="data-loading-popup">

        <q-icon
          :allowSelfUpdate="false"
          spin
          width="110px"
          name="spinner" />

      </div>
    </div>
  </light-box>
</template>

<script>
import CampaignMpeEditor from '@/components/service/campaignManager/CampaignMpeEditor'
import Lightbox from '@/components/standard/display/Lightbox'

import QIcon from '@/components/standard/display/QIcon'
import resolver from '@/assets/modules/error/resolver'
import gql from 'graphql-tag'

export default {
  data () {
    return {
      mediaPlanEvents: {},
      fetching: true
    }
  },

  methods: {
    /**
     * Discards current changes
     * @param {Event} e JS event
     */
    discardChanges (e) {
      this.$emit('discardChanges', e)
    },

    /**
     * Saves current changes
     * @param {Object} e Edited MPE object
     */
    saveMpe (e) {
      this.$emit('saveMpe', e)
    }
  },

  computed: {
    /**
     * Tells if data is still fetching
     * @returns {Boolean} If data is still fetching
     */
    isFetching () {
      return this.fetching
    },

    /**
     * Gives raw MPE
     * @returns {Object} MPE that is beeing edited
     */
    getMpe () {
      return (this.mediaPlanEvents.set || [])[0] || null
    },

    /**
     * Transforms raw MPE to MPE editor accepted object
     * @returns {Object} MPE editor accepted MPE object
     */
    getEditMpe () {
      let mpe = this.getMpe
      if (mpe === null) return {}

      let { payload, advertisable, expiresAt, startsAt, type, status } = mpe
      let params = {
        campaignLabel: advertisable.label,
        startsAt,
        expiresAt,
        status
      }

      let newPayload = Object.assign({}, payload)
      let mediaField = resolver.getMediaFieldName(type)
      let media = {}
      for (let m of newPayload[mediaField] || []) {
        media[m.uuid] = true
      }
      newPayload[mediaField] = media

      return {
        payload: newPayload,
        params,
        mpeAdvertisable: advertisable,
        type
      }
    },

    /**
     * Gives edited MPE's media
     * @returns {Array} Array of media objects
     */
    getMedia () {
      let mpe = this.getMpe
      if (mpe === null) return []

      let mfn = resolver.getMediaFieldName(mpe.type)
      return mpe.payload[mfn]
    }
  },

  components: {
    'mpe-editor': CampaignMpeEditor,
    'q-icon': QIcon,
    'light-box': Lightbox
  },

  props: {
    mpeId: {
      required: true,
      default: null
    }
  },

  // Apollo...
  apollo: {
    mediaPlanEvents: {
      query: gql`query ($id: [UUID!]) {
        mediaPlanEvents (id: $id) {
          set {
            id,
            type,
            status,
            startsAt: publishAt,
            expiresAt: removeAt,
            
            advertisable {
              label,
              id
            },
            
            payload {
              ... on MediaPlanEventFacebookPost {
                body: message,
                message,
                link,
                photos {
                  url,
                  uuid: url
                }
              }
              ... on MediaPlanEventSqwizArticle {
                title,
                body,
                images {
                  url,
                  uuid: url
                }
              }
              ... on  MediaPlanEventSqwizProduct{
                title,
                descriptionShort,
                price,
                discountPercent,
                images {
                  url,
                  uuid: url
                }
              }
              ... on MediaPlanEventTwitterTweet {
                status,
                media {
                  url,
                  uuid: url
                }
              },
              ... on MediaPlanEventPinterestPin {
                note,
                link,
                image {
                  url,
                  uuid: url
                }
              },
              ... on MediaPlanEventShopamineProduct {
                name,
                model,
                shortDescription,
                price,
                discount,
                images {
                  url,
                  uuid: url
                }
              },
              ... on MediaPlanEventShopaminePost {
                name,
                shortDescription,
                images {
                  url,
                  uuid: url
                }
              },
              ... on MediaPlanEventInformacijaProduct {
                name,
                model,
                shortDescription,
                price,
                discount,
                images {
                  url,
                  uuid: url
                }
              },
              ... on MediaPlanEventInformacijaPost {
                name,
                shortDescription,
                images {
                  url,
                  uuid: url
                }
              },
              ... on MediaPlanEventWordpressPost {
                title,
                content,
                media {
                  url,
                  uuid: url
                }
              },
              ... on MediaPlanEventWoocommerceProduct {
                name,
                shortDescription,
                description,
                regularPrice,
                salePrice,
                categories,
                images {
                  url,
                  uuid: url
                }
              }
            }
          }
        }
      }`,

      error(error) {
        this.$set(this, 'fetching', false)
      },

      result (ApolloQueryResult) {
        if (!ApolloQueryResult.loading) {
          this.$set(this, 'fetching', false)
        }
      },

      variables () {
        return {
          id: this.mpeId
        }
      },

      fetchPolicy: 'cache-and-network'
    }
  }

}
</script>

<style scoped>
.data-loading-popup {
  padding: 10px 20px;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/service/campaignManager/standaloneMpe/EditorWrapper.vue?0c0fad93